import { Box } from '@chakra-ui/react'

import useColorModeValue from '@/hooks/useColorModeValue'
import { IApprovalDetailChildItem } from '@/types/tasksApprovals'

type TValue = 'approve' | 'reject'

const ApproveRejectButtons = ({
    value,
    onClick,
    item,
}: {
    item: IApprovalDetailChildItem
    value: TValue
    onClick: (value: TValue) => void
}) => {
    const isDisabled = item.isDisabled
    const isApproved = item.isApproved && value === 'approve'
    const isRejected = item.isRejected && value === 'reject'

    const textColor = {
        approve: {
            default: useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)'),
            checked: useColorModeValue('var(--chakra-colors-white)', 'var(--chakra-colors-dark-700)'),
        },
        reject: {
            default: 'var(--chakra-colors-status-error)',
            checked: 'var(--chakra-colors-white)',
        },
    }

    const bgColor = {
        approve: {
            default: useColorModeValue('white', 'transparent'),
            checked: useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-surface-dark)'),
        },
        reject: {
            default: useColorModeValue('white', 'transparent'),
            checked: 'var(--chakra-colors-status-error)',
        },
    }

    const borderColor = {
        approve: {
            default: '#d8d7d5',
            checked: 'var(--chakra-colors-dark-700)',
        },
        reject: {
            default: '#d8d7d5',
            checked: 'var(--chakra-colors-status-error)',
        },
    }
    const color = textColor[value][isApproved || isRejected ? 'checked' : 'default']
    const bg = bgColor[value][isApproved || isRejected ? 'checked' : 'default']
    const border = borderColor[value][isApproved || isRejected ? 'checked' : 'default']

    return (
        <Box
            cursor={isDisabled ? 'not-allowed' : 'pointer'}
            borderWidth="1px"
            borderColor={border}
            bg={bg}
            borderRadius="16px"
            textTransform="capitalize"
            fontSize="14px"
            opacity={isDisabled ? 0.3 : 1}
            color={color}
            px="18px"
            py="4px"
            onClick={() => !isDisabled && onClick(value)}
        >
            {value}
        </Box>
    )
}

export default ApproveRejectButtons
